import { Component, OnInit } from '@angular/core';
import { JWTTokenService } from '../../shared/service/jwt-token-service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private jwtTokenService: JWTTokenService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  async ngOnInit() {
    await this.jwtTokenService.removeToken();
    await this.router.navigate(['/login'], { relativeTo: this.activatedRoute, queryParams: {} });

  }
  loginWithGoogle(): void {
    window.location.href = `${environment.ssoUrl + environment.ssoAuthUrl}`;
  }

}
